<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="title-box"><span class="txt1">凭证信息</span></div>
          <div class="item" v-if="form.beforeStr.registrationPO && form.beforeStr.registrationPO.num">凭证编号：{{form.beforeStr.registrationPO.num}}</div>
          <div class="title-box" v-if="(form.beforeStr.payPOList || []).length"><span class="txt1">付款信息</span></div>
          <div class="bank-box" v-for="(p,idx) in (form.beforeStr.payPOList || [])" :key="idx">
            <div class="item">付款银行：{{p.payBank}}</div>
            <div class="item">金额：{{p.payMoney}}</div>
            <div class="item">付款单号：{{p.payNum}}</div>
            <div class="item">支付时间：{{p.payTime}}</div>
            <div class="item" v-if="p.payImg">
              凭证图片：
              <el-image style="width: 80px; height: 80px" :src="p.payImg" :preview-src-list="[p.payImg]"></el-image>
            </div>
         
          </div>
          <pre v-if="!hasKnownBefore" class="json-view">{{ pretty(form.beforeStr) }}</pre>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="title-box"><span class="txt1">凭证信息</span></div>
          <div class="item" v-if="form.afterStr.registrationPO && form.afterStr.registrationPO.num">凭证编号：{{form.afterStr.registrationPO.num}}</div>
          <div class="title-box" v-if="(form.afterStr.payPOList || []).length"><span class="txt1">付款信息</span></div>
          <div class="bank-box" v-for="(p,idx) in (form.afterStr.payPOList || [])" :key="idx">
            <div class="item">付款银行：{{p.payBank}}</div>
            <div class="item">金额：{{p.payMoney}}</div>
            <div class="item">付款单号：{{p.payNum}}</div>
            <div class="item">支付时间：{{p.payTime}}</div>
            <div class="item" v-if="p.payImg">
              凭证图片：
              <el-image style="width: 80px; height: 80px" :src="p.payImg" :preview-src-list="[p.payImg]"></el-image>
            </div>
           
          </div>
          <pre v-if="!hasKnownAfter" class="json-view">{{ pretty(form.afterStr) }}</pre>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  computed: {
    hasKnownBefore() {
      const b = this.form && this.form.beforeStr
      if (!b) return false
      const hasVoucher = b.registrationPO && b.registrationPO.num
      const hasPays = Array.isArray(b.payPOList) && b.payPOList.length > 0
      return hasVoucher || hasPays
    },
    hasKnownAfter() {
      const a = this.form && this.form.afterStr
      if (!a) return false
      const hasVoucher = a.registrationPO && a.registrationPO.num
      const hasPays = Array.isArray(a.payPOList) && a.payPOList.length > 0
      return hasVoucher || hasPays
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    },
    pretty(obj) {
      try {
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return String(obj)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.json-view {
  background: #fafafa;
  padding: 8px 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  max-height: 360px;
  overflow: auto;
}
.title-box { margin: 10px 0 6px; }
.bank-box { padding: 6px 0; border-bottom: 1px dashed #eee; }
.item { line-height: 22px; }
</style>
